import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=aa968240&"
import script from "./Builder.vue?vue&type=script&lang=ts&"
export * from "./Builder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports